// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2Q6op","subheader":"ReorderModal_subheader__1qCc0","listWrap":"ReorderModal_listWrap__2lKj7"};